const getIdsToUse = parentData => {
  if (!parentData || !parentData.length) return [];
  return parentData.map(({
    id
  }) => id);
};
export default getIdsToUse;
//# sourceMappingURL=get-ids-to-use.js.map